<template>
  <el-row class="wrapper" :class="{ active: active }">
    <el-col :span="24">
      <div class="top" @click="toggle()" style="cursor: pointer">
        <h4 :style="{ color: item.completed ? 'green' : '' }">
          <!-- <i
            v-if="active"
            class="fal fa-chevron-down chevronToggle"
            style="width: 20px; text-align: center"
            :style="{ color: item.color }"
          ></i> -->
          <i
            class="fal fa-chevron-right chevronToggle"
            :class="{ active: active }"
            style="width: 20px; text-align: center"
            :style="{ color: item.color }"
          ></i>
          <span>{{ item.goalText }}</span>
          <div class="linkWrapper" v-if="!item.completed">
            <el-link
              v-if="item.link"
              :href="item.link"
              type="primary"
              target="_blank"
              >{{ item.ctaLabel || "help" }}</el-link
            >
            <el-button v-if="item.route" type="primary" @click="goto">{{
              item.ctaLabel
            }}</el-button>
          </div>
          <i
            v-if="item.goalValue === 1"
            class="selected fas fa-square"
            style="float: right; color: lightgrey; margin-right: 10px"
          ></i>
          <i
            v-if="item.completed"
            class="selected fas fa-check"
            style="float: right; color: green"
          ></i>
        </h4>
      </div>
      <div class="details">
        <div
          v-if="item.goalValue > 1 && !item.completed"
          style="position: relative; width: 100%; height: 30px"
        >
          <span style="color: #c534de; font-weight: bold">{{
            item.goalValue - item.currentValue
          }}</span>
          {{ item.units }} to go
          <!-- <div class="greyProgressBar"></div>
          <div
            class="activeProgress"
            :style="{ width: item.progress + '%' }"
          ></div> -->
        </div>
        <p style="color: grey; margin-top: 0; font-size: 12px">
          {{ item.description }}
        </p>
      </div>
    </el-col>
  </el-row>
</template>
<style scoped>
div.top {
  position: relative;
}
div.details {
  margin-left: 20px;
}
h4 {
  margin-bottom: 5px;
}
.greyProgressBar {
  width: 100%;
  position: absolute;
  height: 20px;
  background: #f1f1f1;
  border-radius: 5px;
}
.activeProgress {
  position: absolute;
  height: 20px;
  background: rgb(253, 29, 29);
  background: linear-gradient(
    90deg,
    rgba(253, 29, 29, 1) 0%,
    rgba(222, 180, 52, 1) 100%
  );
  border-radius: 5px;
}
div.linkWrapper {
  position: absolute;
  right: 0px;
  top: 0px;
}
i.chevronToggle {
  font-size: 10px;
  vertical-align: top;
  line-height: 22px;
  transition: all 0.3s ease;
}
.chevronToggle.active {
  transform: rotateZ(90deg);
}
.wrapper {
  border-bottom: 1px solid #dbdbdb;
  height: 50px;
  overflow: hidden;
  transition: all 0.5s ease;
}
.wrapper.active {
  height: 105px;
}
</style>
<script>
export default {
  name: "Achievement",
  data() {
    return {
      active: this.opened,
    };
  },
  props: {
    opened: Boolean,
    progress: Number,
    completed: Boolean,
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    toggle() {
      this.active = !this.active;
    },
    goto() {
      alert("going somewhere");
    },
  },
};
</script>
